import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import styled from 'styled-components'
import { Button, Col } from 'antd'

import { getFloorList, getZoneList } from 'features/filter/api'
import { GetFloorListReq, GetZoneListReq } from 'features/filter/types'
import { selectFloorList, selectZoneList } from 'features/filter/selector'
import { selectedProjectCodeSelector } from 'features/project/project.selector'
import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'

import { selectFilter } from 'features/cmpj/zone/dashboard/selector'
import { Filter } from 'features/cmpj/zone/dashboard/types'
import { updateFilter } from 'features/cmpj/zone/dashboard/actions'

import { getLeafWbsList } from 'features/wbs/wbs.function'
import { getWbsListSelector } from 'features/wbs/wbs.selector'

import { WbsFilter, FloorFilter, ZoneFilter } from './Components'
import { JsonParam, useQueryParam } from 'use-query-params'
import { useLocation } from 'react-router'
import queryString from 'query-string'

type Props = {
  onSearch?: () => void
  withPadding?: boolean
} & ReduxProps &
  DispatchProps

const CMUnitFilter: React.FunctionComponent<Props> = props => {
  const {
    ProjectCode,
    UserEmail,
    token,
    floorList,
    zoneList,
    filter,
    onSearch = () => {},
    withPadding = false,
    wbsList,
  } = props

  const [search, setSearch] = useQueryParam('search', JsonParam)
  const searchParam = useLocation()

  useEffect(() => {
    onGetFloorList()
    onGetZoneList()

    onBindFilterFromParams()
  }, [ProjectCode, UserEmail, searchParam.search])

  const onBindFilterFromParams = () => {
    if (searchParam.search) {
      const param = queryString.parse(searchParam.search)
      const activityFilter: Filter = JSON.parse(param.search!.toString())
      onFilterChange(activityFilter)
      setSearch(activityFilter)
      onSearch()
    }
  }

  const onGetFloorList = () => {
    const req: GetFloorListReq = {
      ProjectCode,
      UserEmail,
    }
    dispatch(getFloorList(token, req))
  }

  const onGetZoneList = () => {
    const req: GetZoneListReq = {
      ProjectCode,
      UserEmail,
    }
    dispatch(getZoneList(token, req))
  }

  const dispatch = useDispatch()
  const onFilterChange = (filter: Filter) => {
    dispatch(updateFilter(filter))
  }

  const onClick = () => {
    filter.LeafWbsList = getLeafWbsList(wbsList, filter.WbsList)
    dispatch(updateFilter(filter))
    setSearch(filter)
    onSearch()
  }

  return (
    <MainPage className={withPadding ? 'with-padding' : ''}>
      <div className="filters">
        <Col span={24} className="filters-button">
          <WbsFilter
            onFilterChange={onFilterChange}
            filter={filter}
            wbsList={wbsList}
          />

          <FloorFilter
            onFilterChange={onFilterChange}
            filter={filter}
            floorList={floorList.List}
          />

          <ZoneFilter
            onFilterChange={onFilterChange}
            filter={filter}
            zoneList={zoneList.List}
          />
          <Button type="primary" onClick={onClick}>
            กรองข้อมูล
          </Button>
        </Col>
      </div>
    </MainPage>
  )
}

const MainPage = styled.div`
  &.with-padding {
    padding: 0 120px;
  }

  background-color: #f5f6fa;
`

const mapStateToProps = (state: RootState) => {
  return {
    ProjectCode: selectedProjectCodeSelector(state),
    UserEmail: userEmailSelector(state),
    token: serviceTokenSelector(state),
    filter: selectFilter(state),
    floorList: selectFloorList(state),
    zoneList: selectZoneList(state),
    wbsList: getWbsListSelector(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(CMUnitFilter)
